/**
 * `/leagues/:leagueId` also matches the static pages beside it and the
 * /leagues/v2 redirect's first frame, so those segments are not league ids.
 */
const NOT_LEAGUE_IDS = new Set(["new", "adjudication", "v2"]);

export function leagueIdFromPath(raw: string | undefined): string | undefined {
  return raw && !NOT_LEAGUE_IDS.has(raw) ? raw : undefined;
}
